import { Content } from "pdfmake/interfaces";
import { AnalysisItem, HailAdditionalDetails, R } from "helpers/models";
import layout from "report/common/layout";
import gap from "report/common/gap";
import hail from "./hail";

const get = (t: any, analysisItem: AnalysisItem): Content[] => {
  let detail = analysisItem.details as R;
  const hailAdditionalDetails =
    analysisItem.hailAdditionalDetails as HailAdditionalDetails;

  const hail31 =
    hailAdditionalDetails &&
    hailAdditionalDetails["HailHazard-31-year-historical-data-set"];

  const hail64 =
    hailAdditionalDetails &&
    hailAdditionalDetails["HailHazard-64-year-historical-data-set"];

  if (
    analysisItem.layerId !== "DR_Subsidence_France_SwissRe" &&
    analysisItem.layerId !== "WF_DistToBush_AUS_SwissRe"
  ) {
    detail = {
      "Intensity Value": !analysisItem.intensity
        ? "1"
        : analysisItem.intensity.toString(),
      ...detail
    };
  }

  if (
    analysisItem.layerId === "CS_Tornado_Global_SwissRe" &&
    analysisItem.additionalDetails
  ) {
    detail = {
      ...analysisItem.additionalDetails,
      ...detail
    };
  }

  const row = Object.keys(detail)
    .reverse()
    .map((e) => {
      return [
        analysisItem.layerId === "WS_Windspeed_Global_SwissRe" &&
        e === "Storm Peak Gust [m/s]"
          ? t("legend.50y Peak Gust")
          : t("legend." + e),
        {
          text: t("legend." + detail[e]),
          opacity: 0.87
        }
      ];
    });
  return [
    {
      table: {
        headerRows: 0,
        widths: ["*", "*"],
        body: [...row]
      },
      layout: layout(1, false, 6)
    },
    gap(10),
    hail31 && hail(t, "Hail Hazard (31-year historical dataset)", hail31),
    gap(10),
    hail64 && hail(t, "Hail Hazard (64-year historical dataset)", hail64)
  ];
};

export default get;
